import { SET_OBS_IS_VISIBLE } from './constants';

export const setOBSIsVisible = isVisible => ({
    type: SET_OBS_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/OBS/actions.js